import { render, staticRenderFns } from "./user_organ_bind_dialog.vue?vue&type=template&id=4cbd721c"
import script from "./user_organ_bind_dialog.vue?vue&type=script&lang=js"
export * from "./user_organ_bind_dialog.vue?vue&type=script&lang=js"
import style0 from "./user_organ_bind_dialog.vue?vue&type=style&index=0&id=4cbd721c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports